import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import MarketplacePage from "@/pages/MarketplacePage";
import ProductDetail from "@/pages/ProductDetail";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentStatus";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Admin from "@/pages/Admin";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/marketplace" element={<MarketplacePage />} />
      <Route path="/marketplace/:id" element={<ProductDetail />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll>
            <AppRouter />
          </SmoothScroll>
          <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0a0a0a", border: "1px solid rgba(245,245,240,0.12)", color: "#F5F5F0", fontFamily: "JetBrains Mono, monospace", borderRadius: 0 } }} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
